import { z } from 'zod'

export const causalLinkOpinionSchema = z
	.object({
		accident: z
			.object({
				value: z.string(),
				justification: z.string().optional(),
			})
			.strict(),
		diagnoses: z
			.object({
				value: z.string().optional(),
				justification: z.string().optional(),
			})
			.strict()
			.optional(),
		actions: z
			.object({
				value: z.boolean(),
				which: z.string().optional(),
			})
			.strict()
			.refine((data) => !data.value || data.which?.length >= 4, {
				message: 'The minimum length is 4 characters',
				path: ['actions', 'which'],
			}),
	})
	.refine(
		(data) => data.accident.value === 'invalid' || data.diagnoses?.value,
		{
			message: 'Required',
			path: ['diagnoses', 'value'],
		}
	)
	.refine(
		(data) =>
			data.accident.value === 'invalid' ||
			data.diagnoses?.justification?.length >= 4,
		{
			message: 'The minimum length is 4 characters',
			path: ['diagnoses', 'justification'],
		}
	)
